import axios from "../axios.config";

const state = {
  integrationCatalog: [],
  vivoGestaoAccesses: [],
};

const actions = {
  async loadIntegrationCatalog({ commit }) {
    try {
      const { data } = await axios.get("/integrations");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_INTEGRATION_CATALOG", data.data);
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async loadVivoGestaoAccesses({ commit }) {
    try {
      const { data } = await axios.get("/integrations/vivo_gestao/accesses");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_VIVO_GESTAO_ACCESSES", data.data);
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async saveVivoGestaoAccess(_, params) {
    try {
      const { data } = await axios.post("/integrations/vivo_gestao/accesses", params);
      if (data.success === false) {
        throw new Error(data.message);
      }
      return data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async updateVivoGestaoAccess(_, params) {
    try {
      const { data } = await axios.put(
        `/integrations/vivo_gestao/accesses/${params.id}`,
        params
      );
      if (data.success === false) {
        throw new Error(data.message);
      }
      return data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  async deleteVivoGestaoAccess(_, id) {
    try {
      const { data } = await axios.delete(`/integrations/vivo_gestao/accesses/${id}`);
      if (data.success === false) {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  },
};

const mutations = {
  SET_INTEGRATION_CATALOG: (state, data) => {
    state.integrationCatalog = data;
  },
  SET_VIVO_GESTAO_ACCESSES: (state, data) => {
    state.vivoGestaoAccesses = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
